import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import '../QueuePage.scss'
import HrbTranslate from '../../../components/language/HrbTranslate';
import { SortTypes } from '../enums/SortAndFilterTypes';
import QueueHeaderSortLink from './QueueHeaderSortLink';
import ReassignHeaderCheckbox from './reassign/ReassignHeaderCheckbox';
import UnassignedQueueHeaderSortLink from './unassigned/UnassignedQueueHeaderSortLink';
import { QueueTableTypes } from '../enums/QueueTableTypes';
import { SummaryIcons } from '../icons/SummaryIcons';
import classNames from 'classnames'

const QueueTableColumnHeader = ({ queue, sort, onSortChanged, tableType, updateOrderBy, filterState, selectAllTickets, headerCheckboxState, showReassignOption }) => {
    const [reversed, setReversed] = useState(false);
    const [currentSort, setCurrentSort] = useState(filterState?.orderBy);

    useEffect(() => {
        if (queue) {
            if (queue.reversed !== reversed) {
                setReversed(queue.reversed)
            }
        } else {
            setReversed(false);
        }
    }, [queue])

    const handleSort = (sortValue, reversed) => {
        onSortChanged(sortValue, reversed)
    }

    const updateCurrentSort = (sortSelected) => {
        setCurrentSort(sortSelected);
    }

    /* The table type check and UnassignedQueueHeaderSortLink can be removed once Unassigned Tickets view also gets new Filtering and Sorting  */
    return (
        <div className="columns">
            {showReassignOption &&
                <div className='column is-1 adjust-width-checkbox'>
                    <ReassignHeaderCheckbox selectAllTickets={selectAllTickets} headerCheckboxState={headerCheckboxState} />
                </div>}
            <div className={classNames('column ', showReassignOption ? 'is-1 adjust-width-messageIcon' : 'is-2')}>
                {tableType === QueueTableTypes.DEFAULT &&
                    <QueueHeaderSortLink sortValue={SortTypes.HAS_UNREAD_MESSAGES} updateOrderBy={updateOrderBy} updateCurrentSort={updateCurrentSort} currentSort={currentSort} order={filterState.order}>
                        {SummaryIcons.NOTIFICATIONS_ICON}
                    </QueueHeaderSortLink>
                }
            </div>
            {showReassignOption &&
                <div className={classNames('column is-1', { 'adjust-width-productBadge': showReassignOption })} ></div>}
            <div className='column is-4'>
                {tableType === QueueTableTypes.DEFAULT &&
                    <QueueHeaderSortLink sortValue={SortTypes.TICKET_CLIENT_NAME} updateOrderBy={updateOrderBy} updateCurrentSort={updateCurrentSort} currentSort={currentSort} order={filterState.order}>
                        <HrbTranslate text='QueuePage.Labels.Client' />
                    </QueueHeaderSortLink>
                }
                {tableType === QueueTableTypes.UNASSIGNED &&
                    <UnassignedQueueHeaderSortLink sort={sort} sortValue={SortTypes.CLIENT_NAME} reversed={reversed} onSortChanged={handleSort}>
                        <HrbTranslate text='QueuePage.Labels.Client' />
                    </UnassignedQueueHeaderSortLink>
                }
            </div>
            <div className={classNames('column ', showReassignOption ? 'is-2 adjust-chevron-position' : 'is-3')}>
                {tableType === QueueTableTypes.DEFAULT &&
                    <QueueHeaderSortLink sortValue={SortTypes.CLIENT_LAST_ACTIVITY} updateOrderBy={updateOrderBy} updateCurrentSort={updateCurrentSort} currentSort={currentSort} order={filterState.order}>
                        <HrbTranslate text='QueuePage.SortTypes.LastClientActivity' />
                    </QueueHeaderSortLink>
                }
                {tableType === QueueTableTypes.UNASSIGNED &&
                    <UnassignedQueueHeaderSortLink sort={sort} sortValue={SortTypes.CLIENT_ACTIVITY} reversed={reversed} onSortChanged={handleSort}>
                        <HrbTranslate text='QueuePage.SortTypes.LastClientActivity' />
                    </UnassignedQueueHeaderSortLink>
                }
            </div>
            <div className={classNames('column ', showReassignOption ? 'is-2 adjust-chevron-position' : 'is-3')}>
                {tableType === QueueTableTypes.DEFAULT &&
                    <QueueHeaderSortLink currentSort={currentSort} order={filterState.order}>
                        <HrbTranslate text='QueuePage.Labels.Status' />
                    </QueueHeaderSortLink>
                }
                {tableType === QueueTableTypes.UNASSIGNED &&
                    <UnassignedQueueHeaderSortLink sort={sort} sortValue={SortTypes.READY_TO_ASSIGN} reversed={reversed} onSortChanged={handleSort}>
                        <HrbTranslate text='QueuePage.Labels.Status' />
                    </UnassignedQueueHeaderSortLink>
                }
            </div>
            {showReassignOption &&
                <div className='column is-1'></div>}
        </div>
    );
}

QueueTableColumnHeader.propTypes = {
    queue: PropTypes.object,
    onSortChanged: PropTypes.func,
    updateOrderBy: PropTypes.func,
}

export default QueueTableColumnHeader